module.exports = __webpack_public_path__ + "media/partners/unilever-c2b0eefc.svg";